// extracted by mini-css-extract-plugin
export var columnItem = "_f2-3";
export var columnItemDraggable = "_f2-5";
export var dragHandle = "_f2-0";
export var dragHandleHovered = "_f2-1";
export var dropdown = "_f2-6";
export var dropdownContent = "_f2-8";
export var dropdownInner = "_f2-7";
export var filterDropdownHeader = "_f2-9";
export var icon = "_f2-2";
export var moveToTopButton = "_f2-4";
export var sectionDivider = "_f2-a";